import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../utils/api';
import Breadcrumb from '../../components/Breadcrumb';

export default function Noticias() {
  const [noticias, setNoticias] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/noticias').then(r => setNoticias(r.data)).catch(()=>{}).finally(()=>setLoading(false));
  }, []);

  if (loading) return <div style={{ padding:80, textAlign:'center' }}><div className="spinner" /></div>;

  return (
    <div>
      <Breadcrumb items={[{ label:'Wawita', href:'/' }, { label:'Noticias' }]} />
      <div style={{ maxWidth:1100, margin:'0 auto', padding:'60px 24px' }}>
        <h1 style={{ fontFamily:'var(--font-display)', fontSize:42, color:'var(--forest)', marginBottom:8 }}>Noticias y novedades</h1>
        <div style={{ width:60, height:4, background:'#9FBE6A', borderRadius:2, marginBottom:48 }} />
        {noticias.length === 0 ? (
          <div style={{ textAlign:'center', padding:'80px 0', color:'var(--ink-faint)' }}>
            <div style={{ fontSize:56, marginBottom:16 }}>📰</div>
            <h2 style={{ fontFamily:'var(--font-display)', fontSize:24, color:'var(--forest)', marginBottom:8 }}>Pronto compartiremos noticias</h2>
            <p style={{ fontSize:15, color:'var(--ink-light)' }}>Estamos preparando contenido sobre sostenibilidad, nuevos productos y mas.</p>
          </div>
        ) : (
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(320px,1fr))', gap:28 }}>
            {noticias.map(n => (
              <Link key={n.id} to={"/noticias/" + n.slug} style={{ textDecoration:'none' }}>
                <div style={{ background:'#fff', borderRadius:18, overflow:'hidden', boxShadow:'var(--shadow-sm)', transition:'transform 0.2s, box-shadow 0.2s' }}>
                  <div style={{ height:220, overflow:'hidden', background:'linear-gradient(135deg, #e8f3e6, #f0f7f0)', overflow:'hidden', display:'flex', alignItems:'center', justifyContent:'center' }}>
                    {n.imagen_url
                      ? <img src={n.imagen_url} alt={n.titulo} style={{ width:'100%', height:'100%', display:'block', objectFit:'cover' }} />
                      : <span style={{ fontSize:60 }}>🌿</span>}
                  </div>
                  <div style={{ padding:24 }}>
                    {n.categoria && <div style={{ fontSize:10, fontWeight:700, textTransform:'uppercase', letterSpacing:1.5, color:'#9FBE6A', marginBottom:8 }}>{n.categoria}</div>}
                    <h3 style={{ fontFamily:'var(--font-display)', fontSize:20, color:'var(--forest)', marginBottom:10, lineHeight:1.3 }}>{n.titulo}</h3>
                    {n.resumen && <p style={{ fontSize:13, color:'var(--ink-light)', lineHeight:1.6, marginBottom:14 }}>{n.resumen}</p>}
                    <div style={{ fontSize:12, color:'#9FBE6A', fontWeight:700 }}>{new Date(n.created_at).toLocaleDateString('es-CO', { year:'numeric', month:'long', day:'numeric' })}</div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
